// extracted by mini-css-extract-plugin
module.exports = {"settings":"_1II65","settingsDisabled":"_1boYM"};